import styled, { css } from 'styled-components';
import { selectColor } from '@panel/commons';
import { getColor } from '@panel/commons/core/themev3';
import IconExport from '../../assets/icons/exportData.svg';
import IconExportHover from '../../assets/icons/exportDataHover.svg';
import IconExportDisabled from '../../assets/icons/exportDataDisabled.svg';
import IconExportHoverVA from '../../assets/icons/exportDataHoverVA.svg';
import IconExportHoverCM from '../../assets/icons/exportDataHoverCM.svg';
import IconExportHoverUB from '../../assets/icons/exportDataHoverUB.svg';

const site = process.env.REACT_APP_BUILD_SITE;

const ChartsWrapper = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ChartsLabels = styled.div`
  display: flex;
  gap: 25px;
  margin-bottom: 15px;
  position: relative;
`;

const LabelStyled = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ isActive }) =>
    isActive &&
    css`
      font-weight: 600;
    `}
  ${({ disabled, isActive }) =>
    disabled &&
    css`
      color: ${selectColor(isActive ? 'grayMediumDark' : 'grayMediumLight')};
      cursor: not-allowed;
    `}
`;

const LabelMarker = styled.div`
  ${({ isActive }) =>
    isActive &&
    css`
      height: 2.5px;
      width: 56px;
      border-radius: 2px;
      background-color: ${getColor('primary')}
      margin-top: -3px;
  `}
`;

const ChartContainer = styled.div`
  height: 530px;
  //La clase apexcharts-tooltip se usa para trasladar el tooltip del donutChart
  .apexcharts-tooltip {
    transform: translateX(-4px) translateY(-48px);
  }
`;
const ExportButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;

const ExportData = styled.div`
  width: 40px;
  height: 40px;
  background-image: ${({ wasExported }) => (!wasExported ? `url(${IconExport})` : `url(${IconExportDisabled})`)};
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  cursor: ${({ wasExported }) => (!wasExported ? 'pointer' : '')};
  :hover {
    background-image: ${({ wasExported }) => {
      if (wasExported) return `url(${IconExportDisabled})`;
      if (site === 'VAMX') return `url(${IconExportHoverVA})`;
      if (site === 'CMBR') return `url(${IconExportHoverCM})`;
      if (site === 'UBPE') return `url(${IconExportHoverUB})`;
      return `url(${IconExportHover})`;
    }};
  }
`;

export { ChartsWrapper, ChartsLabels, LabelStyled, LabelMarker, ChartContainer, ExportButtonContainer, ExportData };
